<template>
  <div class="wlx-site-manager-wrapper">
    <header class="site-manager-head-con">
      <el-form :inline="true" size="small">
        <el-form-item>
          <el-input v-model="DisplayName" placeholder="站点名称" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getSitesList()">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-circle-plus-outline"
            @click="dialogVisible = true"
          >添加</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-delete" @click="deleteAll()">删除</el-button>
        </el-form-item>
      </el-form>
    </header>
    <el-dialog
      title="添加站点"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      :close-on-press-escape="false"
      width="40%"
      top="3%"
    >
      <el-form ref="form" label-width="110px" size="mini">
        <el-form-item label="站点名称：" required>
          <el-input v-model="addSiteName"></el-input>
        </el-form-item>
        <el-form-item label="所属省市：" required>
          <el-select v-model="addProvinceName" placeholder="请选择省" @change="getCityList">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-select v-model="addCityName" placeholder="请选择市">
            <el-option
              v-for="item in cityList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="培训站点：" required>
          <el-radio v-model="isTrain" label="1">是</el-radio>
          <el-radio v-model="isTrain" label="0">不是</el-radio>
        </el-form-item>
        <el-form-item label="考试站点：" required>
          <el-radio v-model="isExam" label="1">是</el-radio>
          <el-radio v-model="isExam" label="0">不是</el-radio>
        </el-form-item>
        <el-form-item size="large">
          <el-button @click="cancel()">取 消</el-button>
          <el-button type="primary" @click="AddSite()">确 定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="修改站点信息"
      :visible.sync="updateVisible"
      width="50%"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
    >
      <el-form label-width="190px">
        <el-form-item label="站点名称" required>
          <el-input v-model="SiteName"></el-input>
        </el-form-item>
        <el-form-item label="所属省市">
          <el-select v-model="addProvinceName" placeholder="请选择省" @change="getCityList">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-select v-model="addCityName" placeholder="请选择市">
            <el-option
              v-for="item in cityList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否为培训站点">
          <el-radio v-model="isTrain" label="1">是</el-radio>
          <el-radio v-model="isTrain" label="0">不是</el-radio>
        </el-form-item>
        <el-form-item label="是否为考试站点">
          <el-radio v-model="isExam" label="1">是</el-radio>
          <el-radio v-model="isExam" label="0">不是</el-radio>
        </el-form-item>
        <!-- <el-form-item label="举办了认证考试的学校数量">
          <el-input type="number" v-model="SchoolCount"></el-input>
        </el-form-item>
        <el-form-item label="顺利完成的认证考试数量">
          <el-input type="number" v-model="ExamCount"></el-input>
        </el-form-item>
        <el-form-item label="学员参与认证考试人数">
          <el-input type="number" v-model="StuCount"></el-input>
        </el-form-item>
        <el-form-item label="学员取得认证证书人数">
          <el-input type="number" v-model="StuPassCount"></el-input>
        </el-form-item> -->
        <el-form-item style="center">
          <el-button @click="cancel()">取 消</el-button>
          <el-button type="primary" @click="saveUpdateSite()">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-table
      ref="multipleTable"
      :data="SitesList"
      empty-text=" "
      tooltip-effect="dark"
      style="width: 100%;"
      @selection-change="handleSelectionChange"
    >
      <el-table-column prop="id" type="selection" width="55"></el-table-column>
      <el-table-column label="序号" type="index" width="50"></el-table-column>
      <el-table-column prop="SiteName" label="站点名称" show-overflow-tooltip></el-table-column>

      <el-table-column prop="Province" label="省份名称" show-overflow-tooltip></el-table-column>

      <el-table-column prop="City" label="城市名称" show-overflow-tooltip></el-table-column>
      <el-table-column prop="City" label="是否为培训站点" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.IsTrain == 1">是</span>
          <span v-else>否</span>
        </template>
      </el-table-column>
      <el-table-column prop="City" label="是否为考试站点" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.IsExam == 1">是</span>
          <span v-else>否</span>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            size="mini"
            icon="el-icon-edit"
            @click="update(scope.row)"
            type="primary"
            title="修改"
          ></el-button>
          <el-button
            size="mini"
            icon="el-icon-delete"
            type="danger"
            @click="DelSite(scope.row.Id)"
            title="删除"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="u-page-con">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="onPageChangeHandler"
        :current-page="pageIndex"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        v-show="total>0"
        style="text-align: center;"
      ></el-pagination>
    </div>
    <!-- <loadingData v-if="loadingShow"></loadingData> -->
  </div>
</template>

<script>
import { returnStatement } from "babel-types";
export default {
  data() {
    return {
      SitesList: [],
      dialogVisible: false,
      updateVisible: false,
      addSiteName: "",
      addProvinceName: "",
      addCityName: "",
      SiteInfo: {},
      SiteId: "",
      SiteName: "",
      Province: "",
      City: "",
      isTrain: "",
      isExam: "",
      SchoolCount: 0,
      ExamCount: 0,
      StuCount: 0,
      StuPassCount: 0,
      DisplayName: "",
      pageIndex: 0,
      pageSize: 10,
      total: 0,
      introduceNodeIds: [],
      options: [],
      cityList: []
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.auth;
    }
  },
  created() {
    this.getAllProvinceList();
    this.getSitesList();
  },
  methods: {
    handleSelectionChange(val) {
      this.introduceNodeIds = [];
      val.forEach(element => {
        this.introduceNodeIds.push(element.Id);
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getSitesList();
    },
    onPageChangeHandler(val) {
      this.pageIndex = val;
      this.getSitesList();
    },
    cancel() {
      this.dialogVisible = false;
      this.addSiteName = "";
      this.addProvinceName = "";
      this.addCityName = "";
      this.updateVisible = false;
      this.cityList = [];
      this.isTrain = "";
      this.isExam = "";
    },
    //获取站点列表
    getSitesList() {
      var that = this;
      this.$http
        .post("/api/XOrg/AssociationSites/getSitesList", {
          siteName: that.DisplayName,
          PageSize: that.pageSize,
          page: that.pageIndex
        })
        .then(function(res) {
          if (res.code > 0) {
            that.SitesList = res.siteList;
            that.pageIndex = res.pagination.pageIndex;
            that.pageSize = res.pagination.pageSize;
            that.total = res.pagination.totalCount;
          } else {
            that.$message.warning(res.msg);
          }
        });
    },
    //添加站点
    AddSite() {
      var that = this;
      if (that.isTrain == "") {
        that.$message.warning("培训站点不可为空");
        return false;
      }
      if (that.isExam == "") {
        that.$message.warning("考试站点不可为空");
        return false;
      }
      this.$http
        .post("/api/XOrg/AssociationSites/addSite", {
          siteName: that.addSiteName,
          province: that.addProvinceName,
          city: that.addCityName,
          isTrain: that.isTrain,
          isExam: that.isExam
        })
        .then(function(res) {
          if (res.code > 0) {
            that.getSitesList();
            that.$message.success(res.msg);
            that.cancel();
          } else {
            that.$message.warning(res.msg);
          }
        });
    },
    update(row) {
      var that = this;
      that.updateVisible = true;
      (that.SiteId = row.Id), (that.SiteName = row.SiteName);
      that.addProvinceName = row.Province;
      that.addCityName = row.City;
      that.SchoolCount = row.SchoolCount;
      that.ExamCount = row.ExamCount;
      that.StuCount = row.StuCount;
      that.StuPassCount = row.StuPassCount;
      that.isTrain = row.IsTrain;
      that.isExam = row.IsExam;
      that.introduceNodeIds = [];
      that.getCityList();
    },
    //修改站点
    saveUpdateSite() {
      var that = this;
      if (that.SiteName == "") {
        this.$message.warning("站点名称不可为空");
        return false;
      }
      if (that.addProvinceName == "") {
        this.$message.warning("省份不可为空");
        return false;
      }
      this.$http
        .post("/api/XOrg/AssociationSites/updateSite", {
          siteId: that.SiteId,
          siteName: that.SiteName,
          province: that.addProvinceName,
          city: that.addCityName,
          schoolCount: that.SchoolCount,
          examCount: that.ExamCount,
          stuCount: that.StuCount,
          stuPassCount: that.StuPassCount,
          isTrain: that.isTrain,
          isExam: that.isExam
        })
        .then(function(res) {
          if (res.code > 0) {
            that.getSitesList();
            that.$message.success(res.msg);
            that.cancel();
          } else {
            that.$message.warning(res.msg);
          }
        });
    },
    //批量删除
    deleteAll() {
      if (this.introduceNodeIds.length === 0) {
        this.$message({
          showClose: true,
          message: "请选择要删除的站点",
          type: "warning"
        });
        return false;
      }
      this.$confirm("此操作将删除所选站点, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.Delete();
        })
        .catch(() => {
          this.$message({ type: "info", message: "已取消删除" });
        });
    },
    //单个删除
    DelSite(id) {
      this.introduceNodeIds.push(id);
      var that = this;
      that
        .$confirm("此操作将删除该站点信息, 是否继续？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          that.Delete();
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    //删除
    Delete() {
      var that = this;
      this.$http
        .post("/api/XOrg/AssociationSites/deleteSite", {
          siteId: that.introduceNodeIds
        })
        .then(rst => {
          if (rst.code > 0) {
            that.$message.success(rst.msg);
            that.getSitesList();
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    //获取省市
    getAllProvinceList() {
      this.$http
        .post("/api/XOrg/AssociationSites/getAllProvinceList", {})
        .then(rst => {
          if (rst.code > 0) {
            this.options = rst.province;
          }
        });
    },
    getCityList() {
      var that = this;
      this.$http
        .post("/api/XOrg/AssociationSites/getCityList", {
          province: that.addProvinceName
        })
        .then(rst => {
          if (rst.code > 0) {
            that.cityList = rst.cityList;
          }
        });
    }
  }
};
</script>

<style lang="scss">
.wlx-site-manager-wrapper {
  .site-manager-head-con {
    text-align: right;
    border-bottom: 1px solid #e7ecf4;
  }
}
</style>

